import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledFilterButton = styled.button`
  border: none;
  border-bottom: 1px solid ${colours.elexonBlack};
  font-size: ${fonts.smallMedium};
  margin-top: 8px;
  margin-bottom: 16px;
  padding-bottom: 2px;
  padding-left: 0;
  padding-right: 0;
  background-color: transparent;

  &:hover {
    border-bottom: 3px solid ${colours.elexonBlack};
    padding-bottom: 0;
    cursor: pointer;
  }

  &:focus-visible {
    outline: 1px solid ${colours.focusBlue};
    border-radius: 2px;
  }

  &.active {
    border-bottom: 3px solid ${colours.elexonBlue};
    padding-bottom: 1px;

    font-weight: ${fonts.semibold};

    &:hover {
      text-decoration: underline;
    }
  }

  .icon {
    margin-left: 10px;
  }
`;

export const AppliedFiltersContainer = styled.div`
  display: flex;
  align-content: center;
  margin-bottom: 8px;
`;

export const AppliedFilterTagsList = styled.div`
  display: flex;
  gap: 10px;
  flex-grow: 1;
  flex-wrap: wrap;

  & p {
    font-weight: ${fonts.semibold};
  }
`;

export const AppliedFilterTag = styled.div`
  border: 1px solid ${colours.elexonBlue};
  border-radius: 23px;
  color: ${colours.elexonBlue};
  padding: 0 10px;
  line-height: 1.7em;
`;

export const FiltersModalSection = styled.div`
  margin-bottom: 1em;
`;
